import React from 'react';
import PropTypes from 'prop-types';
import isEnterOrSpace from '../../helpers/isEnterOrSpace';


const Link = ({
  action,
  href,
  children,
  className,
  external,
}) => {
  const hasLocationalHref = href && href.length > 0 && href !== '#';
  const hasCallableAction = action instanceof Function;
  const preventDefaultEvent = hasCallableAction || !hasLocationalHref;

  const handleEvent = (event) => {
    if (preventDefaultEvent) {
      event.preventDefault();
    }

    if (hasCallableAction) {
      action(event);
    }

    if (preventDefaultEvent && hasLocationalHref) {
      if (external) {
        window.open(href);
      } else {
        window.location = href;
      }
    }
  };

  const targetProps = external ?
    {
      rel: 'noopener noreferrer',
      target: '_blank',
    } :
    null;

  return (
    <a
      {...targetProps}
      href={href}
      tabIndex={0}
      className={`link-wrapper ${className}`}
      onClick={handleEvent}
      onKeyPress={event => isEnterOrSpace(event) && handleEvent(event)}
    >
      {children}
    </a>
  );
};

Link.propTypes = {
  action: PropTypes.func,
  href: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element,
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  external: PropTypes.bool,
  className: PropTypes.string,
};
Link.defaultProps = {
  action: null,
  className: '',
  external: false,
};

export default Link;
